import styled from 'styled-components'
import { motion } from 'framer-motion'
import {
  SIDE_PANEL_WIDTH_DEFAULT,
  SIDE_PANEL_WIDTH_RESPONSIVE,
  SIDE_PANEL_WIDTH_2K
} from '../../ReleaseInformation.styles'
import { ScrollableContent } from '../../ReleaseInformation.styles'
import {
  RELEASE_INFORMATION_LAYOUT_QUERIES,
  releaseInfoPromoWideUpQuery,
  releaseInfoSmallDesktopQuery,
  releaseInfoSmallDesktopUpQuery,
  releaseInfoTabletDownQuery
} from '../../responsiveQueries'

export const MotionSidePanel = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  width: ${SIDE_PANEL_WIDTH_DEFAULT}px;
  height: 95svh;
  background: ${({ theme }) => theme.colors.neutralW10};
  border-left: 1px solid ${({ theme }) => theme.colors.neutralW30};
  box-shadow: -2px 0 16px rgba(0, 0, 0, 0.6);
  z-index: 200;
  overflow: hidden;

  @media ${releaseInfoSmallDesktopQuery} {
    width: ${SIDE_PANEL_WIDTH_RESPONSIVE}px;
  }

  @media ${RELEASE_INFORMATION_LAYOUT_QUERIES.sidePanelUltraWideUp} {
    width: ${SIDE_PANEL_WIDTH_2K}px;
  }

  .panel-header {
    display: flex;
    gap: 24px;
    padding: 32px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    background: ${({ theme }) => theme.colors.neutralW20};

    h4 {
      color: white;
    }

    button {
      background: none;
      border: none;
      color: white;
      font-size: 20px;
      cursor: pointer;
    }
  }

  @media ${releaseInfoTabletDownQuery} {
    width: 100%;
  }

  ${ScrollableContent} {
    height: calc(79svh - 64px);
    overflow-y: auto;
    padding: 32px;
  }
`

export const HoverOverlayButton = styled.div`
  position: absolute;
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 1;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1;

  @media ${releaseInfoSmallDesktopUpQuery} {
    opacity: 0;
  }
`

export const Promo = styled.div`
  display: flex;
  padding: 16px;
  max-height: calc(100vh - 400px);
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 24px;
  border: ${({ theme }) => `1px solid ${theme.colors.neutralW30}`};
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%), #222;

  position: relative;

  &:hover {
    ${HoverOverlayButton} {
      opacity: 1;
      pointer-events: auto;
    }
  }

  @media ${releaseInfoSmallDesktopUpQuery} {
    max-height: calc(100vh - 510px);
  }

  @media ${releaseInfoPromoWideUpQuery} {
    max-height: calc(100vh - 610px);
  }
  @media ${RELEASE_INFORMATION_LAYOUT_QUERIES.promoExtraWideUp} {
    max-height: calc(100vh - 650px);
  }
`

export const PromoContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 16px;
  background: #141414;
  overflow: hidden;
`

export const PromoContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  border-radius: 5px;
  max-height: 100%;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 4px;
  }
`
